import { render, staticRenderFns } from "./edit-cate.vue?vue&type=template&id=62878b0a&"
import script from "./edit-cate.vue?vue&type=script&lang=ts&"
export * from "./edit-cate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-cate.vue"
export default component.exports